<template>
    <v-menu
        ref="menu"
        :close-on-content-click="false"
		:disabled="readonly"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
    >
        <template v-slot:activator="{ on, attrs }">
            <template v-if="text">
                <a class="text-body-2 font-weight-light"
                    :key="trigger"
                    v-bind="attrs"
                    v-on="on"
                    @blur="date = parseDate(dateFormatted)"
                >
                    <v-icon>
                        mdi-event
                    </v-icon>
                    <span>
                        {{ dateFormatted }}
                    </span>
                </a>
            </template>
            <template v-else>
                <v-text-field
                    v-model="dateFormatted"
                    :rules="rules"
					:disabled="readonly"
                    :class="textfieldClass"
                    :hide-details="hideDetails"
					:background-color="bgColor"
                    label="日付"
                    placeholder="2020/10/10"
                    readonly
                    prepend-inner-icon="event"
                    v-bind="attrs"
                    @blur="date = parseDate(dateFormatted)"
                    v-on="on"
                    outlined solo flat dense
                />
            </template>
        </template>
        <v-date-picker v-model="date"
                        no-title
                        type='date'
                        :locale="locale"
                        :min="min"
                        :max="max"
                        @input="$refs.menu.save(date); $emit('change');"
        />
    </v-menu>
</template>

<script>
export default {
    //ref ->> Date pickers - formatting date (https://vuetifyjs.com/en/components/date-pickers/#date-month-pickers)
    name: 'UiDatePicker',
    model: {
        prop: 'value',
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        rules: {
            type: Array,
            default () {
                return [];
            }
        },
        textfieldClass: {
            type: String,
            default: ''
        },
        hideDetails: {
            type: Boolean,
            default: false
        },
        minDate: {
            type: String,
            default: ''
        },
        maxDate: {
            type: String,
            default: ''
        },
        text: {
            type: Boolean,
            default: false
        },
        locale: {
            type: String,
            default: undefined
        },
		readonly: {
            type: Boolean,
            default: false
		},
    },
    data(){
        return {
            date: '',
            menu: false,
        }
    },
    computed: {
        dateFormatted: {
            get () {
                return this.value
            },
            set(val) {
                if (!this.readonly) this.$emit('input', val);
            }
        },
        min: function(){
            return this.parseDate(this.minDate);
        },
        max: function(){
            return this.parseDate(this.maxDate);
		},
		bgColor() {
			return this.readonly ? 'grey lighten-2' : undefined;
        }
    },
    watch: {
        date (val) {
            this.dateFormatted = this.formatDate(this.date)
        },
    },
    created() {
        let day = new Date();
        this.date = this.parseDate(this.value || (
            day.getFullYear() + '-' + ('0' + (day.getMonth() + 1)).slice(-2) + '-' + ('0' + day.getDate()).slice(-2)
        ));
        this.dateFormatted = this.formatDate(this.date);
    },
    methods: {
        formatDate (date) {
            if (!date) return null
            const [year, month, day] = date.split('-');
            return `${year}/${month}/${day}`
        },
        parseDate (dateFormatted) {
            if (!dateFormatted) return null
            const [year, month, day] = dateFormatted.split(' ')[0].split('/');
            return `${year}-${( '00' + month ).slice( -2 )}-${( '00' + day ).slice( -2 )}`
        },
    },
}
</script>